'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _underscore = require('../utils/underscore');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _UIFullScreen = require('./UIFullScreen');

var _UIFullScreen2 = _interopRequireDefault(_UIFullScreen);

var _UIModalDialog = require('./UIModalDialog');

var _UIModalDialog2 = _interopRequireDefault(_UIModalDialog);

var _decorators = require('../utils/propTypes/decorators');

var _PanelContext = require('../context/PanelContext');

var PanelContext = _interopRequireWildcard(_PanelContext);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var inPanelContext = { inPanel: true };

exports.default = _react2.default.createClass({
  displayName: 'UIModalPanel',

  propTypes: _extends({}, (0, _underscore.omit)(_UIModalDialog2.default.propTypes, ['size', 'use']), {
    children: _react.PropTypes.node.isRequired,
    panelKey: (0, _decorators.hidden)(_react.PropTypes.string),
    _contextual: _react.PropTypes.bool.isRequired
  }),

  contextTypes: {
    sandboxed: _react.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return _extends({}, _UIModalDialog2.default.defaultProps, {
      width: 700,
      _contextual: false
    });
  },
  render: function render() {
    var _props = this.props,
        children = _props.children,
        _contextual = _props._contextual,
        __panelKey = _props.panelKey,
        width = _props.width,
        rest = _objectWithoutProperties(_props, ['children', '_contextual', 'panelKey', 'width']);

    var renderedModalDialog = _react2.default.createElement(
      PanelContext.Provider,
      { value: inPanelContext, _use: 'sidebar' },
      _react2.default.createElement(
        _UIModalDialog2.default,
        _extends({}, rest, {
          contextual: _contextual,
          _use: 'sidebar',
          _dialogWidth: width
        }),
        children
      )
    );

    var sandboxed = _contextual || this.context.sandboxed;
    return sandboxed ? renderedModalDialog : _react2.default.createElement(
      _UIFullScreen2.default,
      null,
      renderedModalDialog
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1282/js/dialog/UIModalPanel.js
// module id = 327
// module chunks = 0